import {gql} from "@apollo/client";

export const userSubmitGTBQuery = gql`
    mutation userSubmitGTB(
        $userId: Int,
        $huntId: Int,
        $prediction: Float
    ) {
        userSubmitGTB(
            userId: $userId,
            huntId: $huntId,
            prediction: $prediction
        ) {
            id
        }
    }
`;
export const userSubmitGTBMultiQuery = gql`
    mutation userSubmitGTBMulti(
        $userId: Int,
        $huntId: Int,
        $prediction: Float
    ) {
        userSubmitGTBMulti(
            userId: $userId,
            huntId: $huntId,
            prediction: $prediction
        ) {
            id
        }
    }
`;

export const ADMIN_TOGGLEGTB = gql`
    mutation toggleGTB($huntId: Int, $gtbEnabled:Boolean){
        toggleGTB(huntId:$huntId,gtbEnabled: $gtbEnabled){
            gtbEnabled
        }
    }
`;

export const ADMIN_UPDATEHUNTPAYOUT = gql`
    mutation setHuntPayout($huntId:Int, $payout: Float, $multiplier: Float){
        setHuntPayout(huntId:$huntId, payout: $payout, multiplier: $multiplier){ id huntId payout multiplier }
    }
`;

export const ADMIN_UPDATEFIRSTPLACE = gql`
    mutation setHuntWinnerFirst($huntId: Int, $user: Int, $prize: String){
        setHuntWinnerFirst(huntId:$huntId, user: $user, prize: $prize){ id }
    }
`;

export const ADMIN_UPDATESECONDPLACE = gql`
    mutation setHuntWinnerSecond($huntId: Int, $user: Int, $prize: String){
        setHuntWinnerSecond(huntId:$huntId, user: $user, prize: $prize){ id }
    }
`;

export const ADMIN_UPDATETHIRDPLACE = gql`
    mutation setHuntWinnerThird($huntId: Int, $user: Int, $prize: String){
        setHuntWinnerThird(huntId:$huntId, user: $user, prize: $prize){ id }
    }
`;

export const ADMIN_UPDATEMULTIPLACE = gql`
    mutation setHuntWinnerMulti($huntId: Int, $user: Int, $prize: String){
        setHuntWinnerMulti(huntId:$huntId, user: $user, prize: $prize){ id }
    }
`;

export const USER_GET_NEW_CONNECTIONCODE = gql`
    mutation getNewConnectionCode{
        getNewConnectionCode{ code expire }
    }
`;

export const USER_RECHECK_VALIDITY = gql`
    mutation userCheckValidity{
        userCheckValidity{ isValid }
    }
`;

export const CLAIM_ITEM_FROM_STORE = gql`
    mutation claimStoreItem($storeItemId: Int){
        claimStoreItem(storeItemId: $storeItemId){ itemId userId id }
    }
`;

export const ADMIN_UPDATELEADERBOARDPRIZE = gql`
    mutation updateLeaderboardPrize($position: Int!, $reward: Int!){
        updateLeaderboardPrize(position: $position, reward: $reward){ Updated }
    }
`;

export const ADMIN_UPDATELEADERBOARDPRIZEHD = gql`
    mutation updateLeaderboardHypedropPrize($position: Int!, $reward: Int!){
        updateLeaderboardHypedropPrize(position: $position, reward: $reward){ Updated }
    }
`;


//Tournament
export const updateNameAndPayoutFirst = gql`
    mutation updateNameAndPayoutFirst(
        $tournamentId: Int,
        $roundId: Int,
        $name: String,
        $payout: Int
    ) {
        updateNameAndPayoutFirst(
            tournamentId: $tournamentId,
            roundId: $roundId,
            name: $name,
            payout: $payout,
        ) {
            roundNumber
        }
    }
`;

export const updateNameAndPayoutSecond = gql`
    mutation updateNameAndPayoutSecond(
        $tournamentId: Int,
        $roundId: Int,
        $name: String,
        $payout: Int
    ) {
        updateNameAndPayoutSecond(
            tournamentId: $tournamentId,
            roundId: $roundId,
            name: $name,
            payout: $payout,
        ) {
            roundNumber
        }
    }
`;

//Raffles
export const CLAIM_TICKET_IN_RAFFLE = gql`
    mutation claimTicketInRaffle($raffleId: Int){
        claimTicketInRaffle(raffleId: $raffleId){ raffleId ticketNumber userId }
    }
`;
export const PICK_RAFFLE_WINNER = gql`
    mutation pickRaffleWinner($raffleId: Int){
        pickRaffleWinner(raffleId: $raffleId){ ticketNumber userId user{
            displayName
        } }
    }
`;
export const CREATE_NEW_RAFFLE = gql`
    mutation createNewRaffle{
        createNewRaffle{
            id
        }
    }
`;
export const TRASH_RAFFLE = gql`
    mutation trashRaffle($raffleId: Int){
        trashRaffle(raffleId: $raffleId){
            id
        }
    }
`;
export const UPDATE_RAFFLE_INFORMATION = gql`
    mutation updateRaffle(
        $raffleId: Int, 
        $title: String,
        $description: String,
        $maxTickets: Int,
        $maxEntriesPerUser: Int,
        $price: Int,
        $winners: Int,
        $startsAt: String,
        $endsAt: String,
        $imageUrl: String
    ){
        updateRaffle(
            raffleId: $raffleId
            title: $title
            description: $description
            maxTickets: $maxTickets
            maxEntriesPerUser: $maxEntriesPerUser
            price: $price
            winners: $winners
            startsAt: $startsAt
            endsAt: $endsAt
            imageUrl: $imageUrl
        ){
            id
            title
            description
        }
    }
`;

export const UPDATE_STORE_ITEM = gql`
    mutation updateStoreItem(
        $storeItemId: Int,
        $title: String,
        $description: String,
        $price: Int,
        $totalClaims: Int,
        $remainingClaims: Int,
        $isClaimable: Int,
        $imageUrl: String
    ){
        updateStoreItem(
            storeItemId: $storeItemId
            title: $title
            description: $description
            price: $price
            totalClaims: $totalClaims
            remainingClaims: $remainingClaims
            isClaimable: $isClaimable
            imageUrl: $imageUrl
        ){
            id
        }
    }
`;

export const CREATE_NEW_ITEM = gql`
    mutation createNewItem{
        createNewItem{
            id
        }
    }
`;

export const UPDATE_BTC_ADDRESS = gql`
    mutation updateBTCAddress(
        $btcAddress: String!
    ){
        updateBTCAddress(
            btcAddress: $btcAddress
        ){
            Updated
        }
    }
`;

export const UPDATE_LTC_ADDRESS = gql`
    mutation updateLTCAddress(
        $ltcAddress: String!
    ){
        updateLTCAddress(
            ltcAddress: $ltcAddress
        ){
            Updated
        }
    }
`;

export const UPDATE_ETH_ADDRESS = gql`
    mutation updateETHAddress(
        $ethAddress: String!
    ){
        updateETHAddress(
            ethAddress: $ethAddress
        ){
            Updated
        }
    }
`;

export const UPDATE_USDT_ADDRESS = gql`
    mutation updateUSDTAddress(
        $usdtAddress: String!
    ){
        updateUSDTAddress(
            usdtAddress: $usdtAddress
        ){
            Updated
        }
    }
`;


export const UPDATE_GAMDOM_ID = gql`
    mutation updateGamdomId(
        $gamdomId: Int!
    ){
        updateGamdomId(
            gamdomId: $gamdomId
        ){
            Updated
        }
    }
`;
